
























































import { Component, Vue, Prop } from "vue-property-decorator";
import { getStoreMenus } from "@/config/store_menus";
import { Menu } from "@/typescript/models/store_menus/types";
import { isSideIpad } from "@/typescript/lib/common/is_ipad";
import { getPermission } from "@/typescript/lib/common/get_permission";
export { Menu };

@Component
export default class SidebarComponent extends Vue {
  @Prop()
  storeId!: number;
  permission: any;

  generalMenus(storeId: number): Menu[] {
    return getStoreMenus(storeId, this.$store.state.activeId).slice(0, 5);
  }
  settingMenus(storeId: number): Menu[] {
    return getStoreMenus(storeId, this.$store.state.activeId).slice(5, 7);
  }

  get isFolding(): boolean {
    return this.$store.state.isFolding;
  }

  isActive(id: number): boolean {
    return this.$store.state.activeId === id;
  }

  active(clickId: number): string {
    return this.isActive(clickId) ? "active" : "";
  }

  handleResize(): void {
    if (this.$store.state.isFolding) return;

    if ((!this.$store.state.isFolding && isSideIpad()) || isSideIpad()) {
      this.$store.commit("setIsFolding", {
        isFolding: true
      });
      return;
    }

    this.$store.commit("setIsFolding", {
      isFolding: false
    });
  }

  isShow(id: Number) {
    // 設定メニュー表示
    if (id === 5) {
      if (
        this.permission.isAdmin ||
        this.permission.isMainte ||
        this.permission.isMatter ||
        this.permission.isArea
      )
        return true;
    }
    // 店舗管理メニュー表示
    else if (id === 6) {
      if (this.permission.isAdmin || this.permission.isMainte) return true;
    }

    return false;
  }

  created() {
    window.addEventListener("resize", this.handleResize);
    window.addEventListener("load", this.handleResize);
    this.permission = getPermission(this.$store.state.authInfo.authority);
  }
}
